import React from 'react';
import { Button, ButtonProps } from '@mui/material';

/**
 * Secondary button component for cancel/secondary actions
 * Uses neutral gray colors for less prominent actions
 */
export const SecondaryButton: React.FC<ButtonProps> = ({ sx, ...props }) => {
  return (
    <Button
      variant="outlined"
      {...props}
      sx={{
        color: '#666',
        borderColor: '#d0d0d0',
        fontWeight: 600,
        '&:hover': {
          borderColor: '#999',
          bgcolor: '#f5f5f5',
        },
        '&:active': {
          borderColor: '#666',
          bgcolor: '#e8e8e8',
        },
        '&.Mui-disabled': {
          borderColor: '#e8e8e8',
          color: '#ccc',
        },
        ...sx,
      }}
    />
  );
};
